import { useMutation } from '@apollo/client';
import { useState } from 'react';
import {
  CreatePaymentResponse,
  PaymentProvider,
  PaymentStatus,
} from '@/api/types/payments.types';
import { CREATE_PAYMENT } from '@/api/mutations/payments.mutations';
import { MutationError } from '@/api/types/common.types';

type UseCreatePaymentParams = {
  onSuccess?: (data: CreatePaymentResponse) => void;
  onError?: (status: PaymentStatus, errors?: MutationError[]) => void;
  onRedirect?: (redirectUrl: string) => void;
};

export const useCreatePayment = ({
  onSuccess,
  onError,
  onRedirect,
}: UseCreatePaymentParams) => {
  const [createPayment, { loading }] = useMutation<CreatePaymentResponse>(
    CREATE_PAYMENT,
    {
      onCompleted: onCreatePaymentComplete,
    }
  );

  const [paymentProvider, setPaymentProvider] =
    useState<PaymentProvider | null>(null);

  function onCreatePaymentComplete(data: CreatePaymentResponse) {
    const errors = data?.createPayment?.errors;
    const { status, redirectUrl } = data.createPayment.entity;
    const isSuccess = status === PaymentStatus.Success;

    if (errors?.length || (!redirectUrl && !isSuccess)) {
      onError && onError(status, errors);
    }

    if (data.createPayment.entity.provider) {
      setPaymentProvider(data.createPayment.entity.provider);
    }

    if (redirectUrl && status === PaymentStatus.ContinueToWebsite) {
      onRedirect && onRedirect(redirectUrl);
    }
    if (isSuccess) {
      onSuccess && onSuccess(data);
    }
  }

  return {
    createPayment,
    loading,
    paymentProvider,
  };
};
